import { formatAmount, getTransactionDisplayName } from '@/lib/utils'

export type TransactionCreatedData = {
  actor_name?: string | null
  store_name?: string | null
  total_amount?: number | null
  item_names?: string[] | null
}

export type RecurringProcessedData = {
  name?: string | null
  amount?: number | null
}

export function formatTransactionCreatedMessage(data: TransactionCreatedData): string {
  const actor = data.actor_name || '誰か'
  const store = getTransactionDisplayName({
    store_name: data.store_name ?? null,
    items: (data.item_names ?? []).map((name) => ({ name })),
  })
  const amount = data.total_amount != null ? ` ${formatAmount(Number(data.total_amount))}` : ''
  return `${actor}が${store}を登録${amount}`
}

export function formatRecurringProcessedMessage(data: RecurringProcessedData): string {
  const name = data.name || '固定支出'
  const amount = data.amount != null ? ` ${formatAmount(Number(data.amount))}` : ''
  return `${name}が自動登録${amount}`
}
